module.exports = __webpack_public_path__ + "img/sdg17_id.ac673ef7.svg";